import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Button, Stack } from 'react-bootstrap';
import { BsChevronLeft } from 'react-icons/bs';

import useGoBack from 'hooks/useGoBack';

type AsProp<C extends React.ElementType> = {
  as?: C;
};

type PropsToOmit<C extends React.ElementType, P> = keyof (AsProp<C> & P);

export type GoBackButtonProps<C extends React.ElementType> = AsProp<C> &
  Omit<React.ComponentPropsWithoutRef<C>, PropsToOmit<C, {
    children?: React.ReactNode;
  }>> & {
    children?: React.ReactNode;
  };

export function GoBackButton<C extends React.ElementType = 'button'>({
  as,
  children = 'Go Back',
  ...props
}: GoBackButtonProps<C>) {
  return (
    <Button as={as} {...(props as any)}>
      <Stack direction="horizontal" gap={2}>
        <BsChevronLeft />
        <span>{children}</span>
      </Stack>
    </Button>
  );
}

export function HistoryBackButton(
  props: Omit<GoBackButtonProps<'button'>, 'onClick'>,
) {
  const { goBack } = useGoBack();
  return <GoBackButton {...props} onClick={() => goBack()} />;
}

type LinkBackButtonProps = Omit<LinkProps, 'as' | 'children'> & {
  to?: string;
  replace?: boolean;
  children?: React.ReactNode;
};

export function LinkBackButton({
  to = '..',
  replace = true,
  children,
  ...props
}: LinkBackButtonProps) {
  return (
    <GoBackButton
      {...props}
      as={Link}
      to={to}
      replace={replace}
    >
      {children}
    </GoBackButton>
  );
}
